'use client';

import { useDialogContext } from './DialogProvider';
import { ConfirmOpts } from './types';

export function useConfirm() {
  const { showConfirm } = useDialogContext();
  return showConfirm;
}